import { Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { ConsumableDto } from "@/core/features/consumables/consumable.dto";
import { SupplierDto } from "@/core/features/suppliers/supplier.dto";

export class ConsumableHasExternalReferenceDto extends BaseEntityDto {
  @Type(() => ConsumableDto)
  consumable: ConsumableDto;
  consumableId: string;

  @Type(() => SupplierDto)
  supplier: SupplierDto;
  supplierId: string;

  externalReference: string;

  toString(): string {
    return `${this.consumable?.name || this.consumableId} - ${this.supplier?.name || this.supplierId}: ${
      this.externalReference
    }`;
  }
}
